import { Button, Form, Input } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import React from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router'

export default withRouter(({ history, title, setTitle }) => {
	const exercises = [
		{
			id: Math.random(),
			title: 'Push ups'
		},
		{
			id: Math.random(),
			title: 'Push ups'
		},
		{
			id: Math.random(),
			title: 'Push ups'
		},
		{
			id: Math.random(),
			title: 'Push ups'
		},
		{
			id: Math.random(),
			title: 'Pull ups'
		}
	]

	return (
		<div>
			<p>Were you looking for one of the following exercises?</p>
			<hr />
			{_.map(exercises, ex =>
				<div key={ex.id}>
					<Link to={`/do/${ex.id}`}>
						<Button>{ex.title}</Button>
					</Link>
				</div>
			)}
			<hr />
			<Form
				onSubmit={ev => {
					ev.preventDefault()
					const exerciseId = 'getRealIdHere'
					history.push(`/do/${exerciseId}`)
				}}
			>
				<p>Nope it&#39;s not there</p>

				<Input
					placeholder="Name put in previous page"
					value={title}
					onChange={(ev, data) => setTitle(data.value)}
				/>
				<br />
				<Button>Do new exercise</Button>
			</Form>
		</div>
	)
})



// WEBPACK FOOTER //
// ./src/pages/Make.js